
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestteethaligners/contact-us",
      function () {
        return require("private-next-pages/bestteethaligners/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestteethaligners/contact-us"])
      });
    }
  